import { TDeviceTutorialKey } from 'app/_modules/pathways';

export const FRONTEND_DEVICE_TUTORIAL_KEYS: TDeviceTutorialKey[] = ['app', 'tablet', 'gateway', 'wifi'];
